// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { skaleCryptoBlades as _skaleCryptoBlades } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the skaleCryptoBlades chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 1026062157
 * Chain Name: SKALE | CryptoBlades
 * Default Block Explorer: https://affectionate-immediate-pollux.explorer.mainnet.skalenodes.com
 * Default RPC URL: https://mainnet.skalenodes.com/v1/affectionate-immediate-pollux
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { skaleCryptoBlades } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: skaleCryptoBlades,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const skaleCryptoBlades = createCommon({
	..._skaleCryptoBlades,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
